import React from 'react'
import { Button, Icon } from 'semantic-ui-react'
import { refreshTariffData } from '../../../src/components/GB_App/api/getGBForm'
import { useDispatch, useSelector } from 'react-redux'
import { initializeItemForm } from '../../../src/components/GB_App/actions'

const RefreshTariffButton = (props) => {
  const [isLoading, setIsLoading] = React.useState(false)

  const invoiceIds = useSelector((state) => state.InvoicesReducer.invoice.invoiceIds)
  const dispatch = useDispatch()

  const refreshTaxLines = async () => {
    setIsLoading(true)
    let response = await refreshTariffData(props.shipId)
    if (response) {
      dispatch(initializeItemForm(response?.data?.eventMessage))
      setIsLoading(false)
    }
  }

  return (
    <Button
      id='refreshtariffbutton'
      size='mini'
      key='Refresh Tariff'
      className='sv todo-button primaryBtn'
      disabled={isLoading ? true : false}
      onClick={() => {
        refreshTaxLines()
      }}
    >
      <Icon style={{ color: '#318192', fontSize: '13px' }} name={'refresh'} />
      {isLoading ? 'PROCESSING...' : 'Refresh Tariff'}
    </Button>
  )
}

export default RefreshTariffButton
